import { useState } from "react";
import { Form, message } from "antd";
import { MailOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import ModalInterface from "../../Modal/Modal";
import { postCollaborators } from "../Infrastructure/Collaborators.service";
import { getByCompany } from "../Application/Collaborators.business";
import Storage from "../../Data/Domain/Storage";
import { AddIcon, CustomFormItem } from "../../Utils/UI/Text";
import CustomError from "../../Utils/Domain/CustomError";

export default function NewCollaborators() {
  const [form] = Form.useForm();

  const [values, setValues] = useState({
    name: "",
    lastname: "",
    email: "",
    password: "",
    company: new Storage("id").getItem(),
  });

  const [formErrors, setFormErrors] = useState({});

  async function handleSubmit() {
    const { name, lastname, email, password, company } = values;

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!passwordRegex.test(password)) {
      setFormErrors({
        password:
          "La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial.",
      });
      return;
    }

    try {
      await postCollaborators({
        name,
        lastname,
        email,
        password,
        company,
      });

      setValues({
        name: "",
        lastname: "",
        email: "",
        password: "",
        company,
      });

      form.resetFields();
      message.success("Se agregó un nuevo Colaborador");
      await getByCompany(company);
      return true;
    } catch (error) {
      const customError = new CustomError(error);
      message.error(customError.message);

      if (customError.message.includes("Email already registered")) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          email: customError.message,
        }));
      }
      return false;
    }
  }

  return (
    <ModalInterface
      children={
        <Form
          layout="vertical"
          responsive={"true"}
          onFinish={handleSubmit}
          form={form}
          initialValues={values}
          onValuesChange={(changedValues, allValues) => {
            const updatedValues = {
              ...values,
              ...allValues,
            };

            if (changedValues.name) {
              updatedValues.name = changedValues.name.replace(
                /[^A-Za-zÁÉÍÓÚáéíóúÑñ\s]/g,
                ""
              );
            }

            if (changedValues.lastname) {
              updatedValues.lastname = changedValues.lastname.replace(
                /[^A-Za-zÁÉÍÓÚáéíóúÑñ\s]/g,
                ""
              );
            }

            setValues(updatedValues);
            form.setFieldsValue(updatedValues);
          }}
        >
          <CustomFormItem
            label="Nombre"
            name="name"
            placeholder="Ingrese su nombre"
            maxLength={30}
            rules={[
              {
                required: true,
                message: "Por favor ingrese su nombre",
                pattern: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/,
              },
            ]}
            tooltipText="Ingrese solo letras y espacios"
            iconSuffix={<UserOutlined />}
            // showCounter
            style={{ width: "100%" }}
            validateStatus={formErrors.name ? "error" : ""}
            help={formErrors.name}
          />

          <CustomFormItem
            label="Apellido"
            name="lastname"
            placeholder="Ingrese su apellido"
            maxLength={30}
            rules={[
              {
                required: true,
                message: "Por favor ingrese su apellido",
                pattern: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/,
              },
            ]}
            tooltipText="Ingrese solo letras y espacios"
            iconSuffix={<UserOutlined />}
            // showCounter
            style={{ width: "100%" }}
            validateStatus={formErrors.lastname ? "error" : ""}
            help={formErrors.lastname}
          />

          <CustomFormItem
            label="Correo Electrónico"
            name="email"
            placeholder="Ingrese su correo electrónico"
            maxLength={50}
            type="email"
            rules={[
              { type: "email", message: "Email no válido" },
              { required: true, message: "Ingresa un valor" },
            ]}
            // showCounter
            tooltipText="Ingrese un correo válido. Ejemplo: usuario@correo.com"
            iconSuffix={<MailOutlined />}
            style={{ width: "100%" }}
            validateStatus={formErrors.email ? "error" : ""}
            help={formErrors.email}
          />

          <CustomFormItem
            label="Contraseña"
            name="password"
            placeholder="Ingrese su contraseña"
            maxLength={25}
            inputType="password"
            // showCounter
            rules={[
              { required: true, message: "Ingresa un valor" },
              {
                pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                message:
                  "La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial.",
              },
            ]}
            tooltipText="La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial."
            iconSuffix={<LockOutlined />}
            style={{ width: "100%" }}
            validateStatus={formErrors.password ? "error" : ""}
            help={
              formErrors.password ||
              "La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial."
            }
          />
        </Form>
      }
      icon={<AddIcon titleAdd="Agregar un nuevo Colaborador" />}
      title="Agregar Colaborador"
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
      text="Agregar"
      handleSubmit={handleSubmit}
      form={form}
    />
  );
}
